import React from 'react';
import { useTranslation } from 'react-i18next';
import SEOHelmet from '../components/SEOHelmet';
import useTiming from '../hooks/useTiming';
import DoorLayout from "../components/Layouts/DoorLayout";
import {Link} from "react-router-dom";

const PostEvent = () => {
  const timing = useTiming();
  const { t } = useTranslation('event');

  return (
    <>
      <SEOHelmet title={timing?.event?.title} />
      <DoorLayout>
        <div className="door-content">
          <div className="mb-6 mt-2 text-center">
            <h1 className="font-bold text-2xl tracking-tight leading-tight">{t('event-is-over')}</h1>
            <p className="text-gray-900">{t('thank-you-for-joining')}</p>
          </div>
          <div className="">
            <Link to="/" className="text-center btn btn-yellow btn-block">{t('back-home')}</Link>
          </div>
        </div>
      </DoorLayout>
    </>
  )
};

export default PostEvent;
